import type { TFunction } from 'i18next'
import {
  //   Palette,
  Settings,
  Wrench,
  Building2,
  Library,
  Languages,
  MessageSquare,
  Package,
  Users,
  Brush,
  Cpu,
  Newspaper,
} from 'lucide-react'
import { SUPPLIERS_LIST_NAV_RESET_STATE } from '@/features/packaging-suppliers/suppliersListNavigation'
import { type SidebarData } from '../types'

export function getSidebarData(translate: TFunction<'common'>): SidebarData {
  return {
    user: {
      name: 'satnaing',
      email: 'satnaingdev@gmail.com',
      avatar: '/avatars/shadcn.jpg',
    },
    navGroups: [
      {
        title: translate('nav.groups.general'),
        items: [
          // {
          //   title: 'Dashboard',
          //   url: '/',
          //   icon: LayoutDashboard,
          // },
          {
            title: translate('nav.items.productCatalog'),
            url: '/product-catalog',
            icon: Package,
          },
          {
            title: translate('nav.items.standardsLibrary'),
            url: '/standards-library',
            icon: Library,
          },
          {
            title: translate('nav.items.associatedParties'),
            url: '/associated-parties',
            icon: Users,
          },
          {
            title: translate('nav.items.packaging'),
            icon: Package,
            permission: 'canAccessPackagingSuppliers',
            items: [
              {
                title: translate('nav.items.packagingSuppliersList'),
                url: '/packaging/suppliers',
                state: SUPPLIERS_LIST_NAV_RESET_STATE,
              },
              {
                title: translate('nav.items.packagingPackedItems'),
                url: '/packaging/packed-items',
              },
              {
                title: translate('nav.items.packagingShipments'),
                url: '/packaging/shipments',
              },
              {
                title: translate('nav.items.packagingPackagingItems'),
                url: '/packaging/packaging-items',
              },
              {
                title: translate('nav.items.packagingIssues'),
                url: '/packaging/issues',
              },
            ],
          },
          {
            title: translate('nav.items.llmChat'),
            url: '/llm-chat',
            icon: MessageSquare,
            permission: 'isArtemEarthEmail',
          },
          {
            title: translate('nav.items.regulatoryNews'),
            url: '/newsroom',
            icon: Newspaper,
            permission: 'isArtemAdmin',
          },
        ],
      },
      {
        title: translate('nav.groups.other'),
        items: [
          {
            title: translate('nav.items.settings'),
            icon: Settings,
            items: [
              {
                title: translate('settings.account'),
                url: '/settings/account',
                icon: Wrench,
              },
              {
                title: translate('settings.organization'),
                url: '/settings/organization',
                icon: Building2,
                permission: 'canWriteOrgData',
              },
              {
                title: translate('settings.llm'),
                url: '/settings/llm',
                icon: Cpu,
                permission: 'canWriteOrgData',
              },
              {
                title: translate('settings.theme'),
                url: '/settings/theme',
                icon: Brush,
              },
              {
                title: translate('settings.language'),
                url: '/settings/language',
                icon: Languages,
              },
            ],
          },
        ],
      },
    ],
  }
}
